
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0.5 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.716 15.696v-1.394L3.35 13.12l-.92-5.063L0 7.308s-.023 1.995 1.442 3.749l-1.25.378s1.498 4.05 5.524 4.261zM19.807 11.435l-1.25-.378C20.023 9.303 20 7.307 20 7.307l-2.43.75-.92 5.062-2.366 1.183v1.394c4.026-.211 5.524-4.261 5.524-4.261zM12.59 2.126a12.77 12.77 0 012.89 1.08C16.113 1.888 17.256.5 17.256.5c-2.405 0-3.862.88-4.665 1.626zM4.52 3.206a12.77 12.77 0 012.89-1.08C6.607 1.38 5.15.5 2.745.5c0 0 1.143 1.388 1.774 2.706zM4.506 6.079a3.832 3.832 0 002.282 1.189l.165.023a4.982 4.982 0 013.05 1.626A4.981 4.981 0 0113.05 7.29l.165-.023a3.832 3.832 0 002.283-1.19l.883-.953c-.964-.69-3.345-2.131-6.38-2.131-3.035 0-5.415 1.442-6.38 2.13l.884.955z","fill":"#F8BF1E"}}),_c('path',{attrs:{"d":"M13.114 16.59l-1.37.87-.628-.99 1.998-1.267v-1.628l2.49-1.244 1.05-5.78-.296.319a5.007 5.007 0 01-2.982 1.554l-.165.022a3.814 3.814 0 00-2.713 1.75l-.496.787-.496-.787a3.814 3.814 0 00-2.713-1.75l-.164-.022A5.007 5.007 0 013.646 6.87l-.295-.32 1.05 5.78 2.49 1.245v1.628l1.997 1.266-.627.99-1.37-.868v.797a3.112 3.112 0 106.223 0v-.797zm.348-6.818l.448 1.083-1.725.714-.448-1.083 1.725-.714zm-7.368 1.083l.448-1.083 1.725.714-.448 1.083-1.725-.714z","fill":"#F8BF1E"}})])
          )
        }
      }
    